export const isObjectWithKeys = <T = unknown>(obj: unknown): obj is { [key: string]: T } => {
  if (typeof obj === 'object' && obj !== null) {
    if (Object.keys(obj).length > 0) return true;
  }
  return false;
};
